export default __webpack_public_path__ + "4630b75087f5aee8e3e755856ba57d81.png";